// Layout 相关的翻译资源（导航和语言选择器）
export const layoutResources = {
  zh: {
    "nav.title": "创生基金",
    // Navigation
    "nav.home": "首页",
    "nav.about": "关于我们",
    "nav.projects": "项目",
    "nav.news": "新闻",
    "nav.report": "公开报告",
    "nav.apply": "申请资助",
    "nav.apply.short": "申请",
    
    // Language selector
    "lang.simplified": "简",
    "lang.traditional": "繁",
    "lang.english": "EN",
    
    // Footer
    "footer.copyright": "版权所有 © 2025 创生基金有限公司保留所有权利",
    "footer.followUs": "关注我们",
    "footer.privacy": "隐私政策",
    "footer.terms": "使用条款",
    "footer.cookie": "Cookie政策",
    "footer.facebook": "Facebook",
    "footer.youtube": "YouTube",
    "footer.facebookAria": "Facebook（新窗口打开）",
    "footer.youtubeAria": "YouTube（新窗口打开）",
  },
  zh_TW: {
    "nav.title": "創生基金",
    // Navigation
    "nav.home": "首頁",
    "nav.about": "關於我們",
    "nav.projects": "項目",
    "nav.news": "新聞",
    "nav.report": "公開報告",
    "nav.apply": "申請資助",
    "nav.apply.short": "申請",
    
    // Language selector
    "lang.simplified": "简",
    "lang.traditional": "繁",
    "lang.english": "EN",
    
    // Footer
    "footer.copyright": "版權所有 © 2025 創生基金有限公司保留所有權利",
    "footer.followUs": "關注我們",
    "footer.privacy": "隱私政策",
    "footer.terms": "使用條款",
    "footer.cookie": "Cookie政策",
    "footer.facebook": "Facebook",
    "footer.youtube": "YouTube",
    "footer.facebookAria": "Facebook（於新視窗開啟）",
    "footer.youtubeAria": "YouTube（於新視窗開啟）",
  },
  en: {
    // Navigation
    "nav.title": "Genovation Foundation",
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.projects": "Projects",
    "nav.news": "News",
    "nav.report": "Public Report",
    "nav.apply": "Apply",
    "nav.apply.short": "Apply",
    
    // Language selector
    "lang.simplified": "简",
    "lang.traditional": "繁",
    "lang.english": "EN",
    
    // Footer
    "footer.copyright": "Copyright © 2025 Genovation Foundation Limited. All rights reserved",
    "footer.followUs": "Follow Us",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.cookie": "Cookie Policy",
    "footer.facebook": "Facebook",
    "footer.youtube": "YouTube",
    "footer.facebookAria": "Facebook (opens in a new tab)",
    "footer.youtubeAria": "YouTube (opens in a new tab)",
  }
};

